// extracted by mini-css-extract-plugin
export default {"VideoPLayerPreloader":"VideoPlayerPreloader_VideoPLayerPreloader__eOOyM","LoaderImage":"VideoPlayerPreloader_LoaderImage__g7qxd","animate":"VideoPlayerPreloader_animate__McQMf"};